import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./metodopagamento.css";

const MetodoPagamentoPage = () => {
  const [metodoSelecionado, setMetodoSelecionado] = useState("");
  const navigate = useNavigate();

  const handleConfirmar = () => {
    if (!metodoSelecionado) {
      alert("Por favor, selecione um método de pagamento.");
      return;
    }

    console.log("Método de pagamento escolhido:", metodoSelecionado);

    // Redireciona para páginas diferentes conforme o método escolhido
    if (metodoSelecionado === "Encomenda") {
      navigate("/pagina-encomenda", {
        state: { metodoPagamento: metodoSelecionado },
      });
    } else {
      navigate("/resumo-final", {
        state: { metodoPagamento: metodoSelecionado },
      });
    }
  };

  return (
    <div className="container mt-5">
      <h2 className="text-center mb-4">🧾 Escolher Método de Pagamento</h2>

      <div className="card p-4 shadow">
        <div className="form-check mb-3">
          <input
            className="form-check-input"
            type="radio"
            name="pagamento"
            id="proforma"
            value="Proforma"
            onChange={(e) => setMetodoSelecionado(e.target.value)}
          />
          <label className="form-check-label" htmlFor="proforma">
            Proforma
          </label>
        </div>

        <div className="form-check mb-4">
          <input
            className="form-check-input"
            type="radio"
            name="pagamento"
            id="encomenda"
            value="Encomenda"
            onChange={(e) => setMetodoSelecionado(e.target.value)}
          />
          <label className="form-check-label" htmlFor="encomenda">
            Encomenda
          </label>
        </div>

        <button className="btn btn-primary" onClick={handleConfirmar}>
          Confirmar Método de Pagamento
        </button>
      </div>
    </div>
  );
};

export default MetodoPagamentoPage;
